'use client';

import { NumericFormat } from 'react-number-format';
import TextField, { TextFieldProps } from '../../inputs/TextField/TextField';
import { ComponentPropsWithoutRef } from 'react';

type CurrencyFieldProps = TextFieldProps &
  ComponentPropsWithoutRef<typeof NumericFormat> & {
    currencySymbol?: string;
  };

export default function CurrencyField({
  currencySymbol = '$',
  ...props
}: CurrencyFieldProps) {
  return (
    <NumericFormat
      {...props}
      prefix={currencySymbol}
      thousandSeparator
      customInput={TextField}
      placeholder={currencySymbol}
      decimalScale={2}
    />
  );
}
